import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import AcedSelect, {
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import AcedInput from "../../../components/essentials/input/text/AcedInput";
import { selectUser } from "../../../core/auth/authSlice";
import { User } from "../../../shared/models";
import http from "../../../shared/utils/http";
import { setUser } from "../../SignUp/redux/SignUp.actions";
import "./CompleteProfileData.scss";

const CompleteProfileData: React.FC = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const user = useSelector(selectUser) as User;
	const { accountType } = useSelector(selectUser) as User;

	const [genderOptions, setGenderOptions] = useState<SelectOptions>([]);

	useEffect(() => {
		if (accountType === undefined) navigate("/type");
	}, []);

	useEffect(() => {
		http.get("/utils/genders").then((response) => {
			setGenderOptions(
				response.map((value: string) => ({
					value,
					label:
						value === "other"
							? "Other"
							: value === "DNS"
								? "Prefer not to answer"
								: value,
				}))
			);
		});
	}, []);

	const onSubmit = (data: any) => {
		let body: any = {
			name: data.name,
			surname: data.surname,
			gender: data.gender,
			country: data.country,
			city: data.city,
		};

		http
			.patch(`/members/member`, body)
			.then((response) => {
				dispatch(setUser({ ...user, ...response }));
				navigate("/sports");
			})
			.catch((error) => console.log(error));
	};

	return (
		<div className="sign-up-info">
			<p className="sign-up-info__caption">{t("profile.profileData.title")}</p>

			<form
				id="complete-profile-data-form"
				className="sign-up-info__form"
				onSubmit={handleSubmit(onSubmit)}
			>
				<div className="d-flex justify-content-center gap-4 flex-wrap">
					<AcedInput
						placeholder={t("profile.profileData.formFieldsLabels.name")}
						control={control}
						name="name"
						rules={{
							required: t(
								"profile.profileData.errors.nameRequired",
								"Name is required"
							),
						}}
					/>
					<AcedInput
						placeholder={t("profile.profileData.formFieldsLabels.surname")}
						control={control}
						name="surname"
						rules={{
							required: t(
								"profile.profileData.errors.surnameRequired",
								"Surname is required"
							),
						}}
					/>
					<div className="d-flex column center w-100">
						<AcedSelect
							control={control}
							options={genderOptions}
							className="w-100"
							placeholder={t(
								"common.words.gender",
								"Gender"
							)}
							name="gender"
							rules={{
								required: t(
									"profile.profileData.errors.genderRequired",
									"Gender is required"
								),
							}}
						/>
					</div>
					<div className="d-flex column center w-100">
						<AcedInput
							placeholder={t("profile.profileData.formFieldsLabels.country")}
							control={control}
							name="country"
							rules={{
								required: t(
									"profile.profileData.errors.countryRequired",
									"Country is required"
								),
							}}
						/>
					</div>

					<div className="d-flex column center w-100">
						<AcedInput
							placeholder={t("profile.profileData.formFieldsLabels.city")}
							control={control}
							name="city"
							rules={{
								required: t(
									"profile.profileData.errors.cityRequired",
									"City is required"
								),
							}}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default CompleteProfileData;
